import { render, staticRenderFns } from "./AubeCoinAutomaticRemittanceComplete.vue?vue&type=template&id=23ac4d69&scoped=true&"
import script from "./AubeCoinAutomaticRemittanceComplete.vue?vue&type=script&lang=js&"
export * from "./AubeCoinAutomaticRemittanceComplete.vue?vue&type=script&lang=js&"
import style0 from "./AubeCoinAutomaticRemittanceComplete.vue?vue&type=style&index=0&id=23ac4d69&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ac4d69",
  null
  
)

export default component.exports